import * as React from "react";
import { pure } from "recompose";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import Sorting from "@tunnel-components/@sharded/sorting/component";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import VirtualLoader from "@tunnel-components/@sharded/@widgets/virtual-loader/component";
import LapiTmdIncidents from "@tunnel-components/@sharded/widgets/box/lapi/component";
import * as Utils from "@Cyclope-Utils/index";
// import * as Enums from '@tunnel-enums/index';
import * as Lodash from "lodash";
// import * as shortid from "shortid";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const {
    loading,
    onSearchFilterCamera,
    onExtractPdfAll,
    datacameralist,
    errorExtractionPdf,
    paramArray,
    onClearIncidentSearch,
    onSearchSubmitFilter,
    endDate,
    selectedValueName,
    onGetValue,
    errorDateRange,
    cameraFilter,
    onEndDateChange,
    startDate,
    onStartDateChange,
    onExtractPdf,
    onExplorerSearchChange,
    explorersearch,
    onExplorerSearch,
    onpensearchboolean,
    isFilter,
    onPenSearchIncidents,
    onFilter,
    onReset,
    errorserver,
    onIncidentActif,
    onSortingBy,
    onIncidentActifOut,
    onUpdateCurrentPageNumber,
    arrayOfIncident,
    onOpen,
    onOpenhoverCard,
    openHoverCard,
    onClosehoverCard,
    onClose,
    filter,
    laPiData,
    noIncidents,
    itemsPerPage,
    totalElements,
    currentPageNumbers,
  } = props;
  /**
   * @description :
   * La variable contient le rôle et les droits
   * de l'utilisateur qui est connecté
   * @const
   * @name User
   * @type { any  }
   */
  // const User : any = Utils.createdUserRoles();
  /**
   * @description : retourne un tableau
   * @const
   * @name cameraSearch
   * @type { any  }
   */

  const cameraSearch: any[] =
    datacameralist &&
    Utils.createAnUniqueArrayFromCameraObject(datacameralist, "cameraLapi");
  /**
   * @description :
   * Authorisation à accéder à certaine resource du site
   * par l'utilisateur
   * @const
   * @name authorization
   * @type { boolean  }
   */
  /**
   * @description : retourne un tableau de type string ( )
   * @const
   * @name csvData
   * @type { any []  }
   */

  const csvData: any =
    !!laPiData &&
    Utils.cloneObjectOrArray(laPiData).map((element: any) => {
      return element;
    });
  // const authorization:  boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.INHIBITIONCREATED]);
  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */
  const rowRenderer = ({ index, key, style }: any): JSX.Element => {
    /**
     * @constant
     * @description :
     * @name  items
     * @types any[]
     */
    const items: any[] = [];
    /**
     * @constant
     * @description :
     * @name  fromIndex
     * @types number
     */
    const fromIndex: number = index;
    /**
     * @constant
     * @description :
     * @name  toIndex
     * @types number
     */
    const toIndex: number = Math.min(fromIndex + 1, laPiData.length);
    {
      /** Boucle */
    }
    for (let i = fromIndex; i < toIndex; i++) {
      {
        /** Création du tableau des items */
      }

      items.push(
        <LapiTmdIncidents
          classnameIncident="incidentTable"
          Elem={!!laPiData[i] && laPiData[i]}
          key={key}
          arrayOfIncident={!!arrayOfIncident && arrayOfIncident[i]}
          onActive={onIncidentActif(i)}
        />
      );
    }
    /**
     * @description:
     */
    return (
      <div
        style={{
          ...style,
          width: "100%",
        }}
      >
        {items}
      </div>
    );
  };

  return (
    <LayoutGrid
      placeholdersearch={i18next.t("rechercher la plaque lapi et tmd")}
      arrayOfLapiIncident={
        arrayOfIncident && arrayOfIncident[Number(paramArray)]
      }
      explorerLapiData={laPiData && laPiData[Number(paramArray)]}
      onActiveOut={onIncidentActifOut}
      lapiFilter={isFilter}
      onCloselapifilter={onFilter}
      onpensearchboolean={onpensearchboolean}
      onPenSearchIncidents={onPenSearchIncidents}
      onDownloadLapiPdf={onExtractPdf(
        !!laPiData[Number(paramArray)] && laPiData[Number(paramArray)].id,
        Number(paramArray)
      )}
      explorersearch={explorersearch}
      onExplorerSearch={onExplorerSearch}
      onExplorerSearchChange={onExplorerSearchChange}
      onSearchSubmitFilter={onSearchSubmitFilter}
      endDate={endDate}
      selectedValueName={selectedValueName}
      onGetValue={onGetValue}
      errorDateRange={errorDateRange}
      cameraFilter={cameraFilter}
      onEndDateChange={onEndDateChange}
      startDate={startDate}
      onStartDateChange={onStartDateChange}
      cameraslapi={cameraSearch}
      someTextError={i18next.t("impossible extraire le pdf")}
      snackbarError={errorExtractionPdf}
      onSearchFilterCamera={onSearchFilterCamera}
      error={errorserver}
      loading={loading}
      authorization={true}
    >
      {
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            links1={Paths.PathsNamesEnums.TMDLAPIEXPLORER}
            bulles={explorersearch}
            onExtractPdf={onExtractPdfAll("direction=DESC&orderBy=id")}
            onClearIncidentSearch={onClearIncidentSearch}
            width="26"
            height="26"
            lapiincons={true}
            title={i18next.t("tmdLapi")}
            breadText1={i18next.t("explorer")}
            filtreLapi={true}
            csvData={csvData}
            onPenSearchIncidents={onPenSearchIncidents}
            onFilter={onFilter}
            onFilterReset={onReset("direction=DESC&orderBy=insertedAt")}
            onOpenhoverCard={onOpenhoverCard}
            openHoverCard={openHoverCard}
            onClosehoverCard={onClosehoverCard}
          />

          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOngletForArray">
              <section className="arrays">
                {
                  <section className="arraysHeader">
                    <span
                      className="arraysHeaderSpanAuto"
                      style={{ width: "12%" }}
                      onMouseLeave={onClose}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(0)}>
                          <p>{i18next.t("date")}</p>
                          <Styled.IconRotate
                            rotates={filter[0]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[0]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            dateBoolean={true}
                            onSortingAZ={onSortingBy(
                              "orderBy=insertedAt&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=insertedAt&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(1)}>
                          <p>{i18next.t("camera")}</p>
                          <Styled.IconRotate
                            rotates={filter[1]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[1]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=cameraCode&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=cameraCode&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(2)}>
                          <p>{i18next.t("non camera")}</p>
                          <Styled.IconRotate
                            rotates={filter[2]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[2]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=cameraName&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=cameraName&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos">
                          <p style={{ cursor: "default" }}>
                            {i18next.t("voies")}
                          </p>
                        </div>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(3)}>
                          <p>{i18next.t("direction")}</p>
                          <Styled.IconRotate
                            rotates={filter[3]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[3]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=direction&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=direction&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(4)}>
                          <p>{i18next.t("plaques")}</p>
                          <Styled.IconRotate
                            rotates={filter[4]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[4]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=plate&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=plate&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(5)}>
                          <p style={{ cursor: "default" }}>
                            {" "}
                            {i18next.t("commentaires")}
                          </p>
                          {false && (
                            <Styled.IconRotate
                              rotates={filter[5]}
                              style={{ width: "8px", right: "-15px" }}
                            >
                              <StyledIcon arrow={true} />
                            </Styled.IconRotate>
                          )}
                        </div>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(6)}>
                          <p> {i18next.t("confiance")}</p>
                          <Styled.IconRotate
                            rotates={filter[6]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[6]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            chiffreBoolean={true}
                            onSortingAZ={onSortingBy(
                              "orderBy=confidence&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=confidence&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(7)}>
                          <p> {i18next.t("nationalite")}</p>
                          <Styled.IconRotate
                            rotates={filter[7]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[7]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=nationality&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=nationality&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                  </section>
                }

                {totalElements !== 0 && itemsPerPage && !noIncidents && (
                  <VirtualPagination
                    key={"lapiKey"}
                    classnames="incident-items " // la classe
                    width="100%" //
                    heightView="100%" // hauteur et largeur de la fenètre
                    rowHeight={53} // Hauteur de la cellule
                    arrayContent={!Lodash.isEmpty(laPiData)} // Boolean vérifie si le tableau est vide
                    rowRenderer={rowRenderer} // élement JSX , column
                    itemPerPage={itemsPerPage} // nombre d'élement par page
                    totalItemLength={totalElements} // nombre total d'élement
                    currentPageNumbers={currentPageNumbers} // la page courante
                    onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // fonction de mise à jour de la page courante
                    itemPerRow={1}
                    totalRowElements={laPiData.length}
                    widthView="100%" //
                  />
                )}
                {noIncidents && <VirtualLoader />}
              </section>
            </section>
          </div>
        </section>
      }
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  datacameralist?: any;
  loading?: any;
  btnloading?: any;
  errorserver?: any;
  onClose?: any;
  filter?: any;
  laPiData?: any;
  noIncidents?: any;
  itemsPerPage?: any;
  totalElements?: any;
  currentPageNumbers?: any;
  onOpenhoverCard?: any;
  openHoverCard?: any;
  onClosehoverCard?: any;
  onOpen?: any;
  arrayOfIncident?: boolean[];
  onUpdateCurrentPageNumber?: any;
  onIncidentActif?: any;
  onIncidentActifOut?: any;
  onSortingBy?: any;
  paramArray?: any;
  onExtractPdf?: any;
  onPenSearchIncidents?: any;
  onFilter?: any;
  onReset?: any;
  isFilter?: any;
  onpensearchboolean?: any;
  // explore search
  explorersearch?: any;
  onExplorerSearch?: any;
  onExplorerSearchChange?: any;

  //
  selectedValueName?: any;
  onGetValue?: any;

  endDate?: any; // ok
  onEndDateChange?: any; // ok
  startDate?: any; // ok
  onStartDateChange?: any; // ok
  errorDateRange?: any;
  cameraSearch?: any;
  cameraFilter?: any;
  onSearchFilterCamera?: any; // ok
  cameraList?: any;
  cameras?: any;
  onSearchSubmitFilter?: any;
  onClearIncidentSearch?: any;
  onExtractPdfAll?: any;
  errorExtractionPdf?: any;
}
/** @export HOC pure */
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/explorer/component.tsx